<template>
  <div class="mt-4">
    <div class="mt-4">
      <div
        v-for="(row, index) of signatures"
        :key="`signaturesprovider-item-${index}`"
        class="result-table"
      >
        <custom-callout
          class-main="mt-3 rounded"
          :has-border="false"
          :has-toggle="false"
        >
          <div class="row py-2 mr-md-0">
            <div class="col-10 mt-3 mt-md-0" style="display: inline-flex;">
              <div
                class="row p-2"
                style="background-color: white; border-radius: 50px;"
              >
                <div
                  :class="`bg-${statusColor(row.participantSignatureStatusId)}`"
                  style="height: 10px !important;
                width: 10px !important;
                border-radius: 20px;
                margin-top: 14px;"
                />
                <span
                  class="font-16 color-black"
                  style="padding-left: 10px; margin-top: 7px;"
                >
                  {{ row.participantSignatureStatus || '' }}
                </span>
              </div>
            </div>
            <div
              v-if="
                row.participantSignatureStatusId ==
                  signatureStatus.PendingSignature
              "
              class="col-2 mt-3 mt-md-0"
            >
              <action-button
                id="btnResend"
                class="mr-1"
                i="fas fa-arrow-circle-right fa-fw"
                text="Reenviar"
                variant="outline-success"
                @click="() => onResendHandler(row.participantEmail, row.userId)"
              />
            </div>
          </div>

          <div class="row py-2 mr-md-0 align-items-center border-top">
            <div class="col-2 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">
                {{
                  positions.includes(row.participantPosition.toUpperCase())
                    ? 'Rol:'
                    : 'Parentesco:'
                }}
              </div>
              <div class="color-black font-16 bold">
                {{ row.participantPosition }}
              </div>
            </div>
            <div class="col-2 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">Nombre:</div>
              <div class="color-black font-16 bold">
                {{ row.participantName }}
              </div>
            </div>
            <div class="col-2 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">
                Tipo de Firma:
              </div>
              <div class="color-black font-16 bold">
                {{
                  data.isElectronicsSignature
                    ? signatureTypeLabels.Electronic
                    : signatureTypeLabels.Handwritten
                }}
              </div>
            </div>
            <div class="col-2 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">Correo Electrónico:</div>
              <div class="color-black font-16 bold">
                {{ row.participantEmail }}
              </div>
            </div>
            <div class="col-2 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">Usuario:</div>
              <div class="color-black font-16 bold">
                {{ row.userName }}
              </div>
            </div>
            <div class="col-2 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">Fecha de Firma:</div>
              <div class="color-black font-16 bold">
                {{
                  row.participantSignatureStatusId !=
                  signatureStatus.PendingSignature
                    ? row.participantSignatureStatusDate
                    : '' | date
                }}
              </div>
            </div>
          </div>
        </custom-callout>
      </div>
    </div>
  </div>
</template>
<script>
//libs components
import ActionButton from 'ActionButton';
import CustomCallout from 'custom-callout';

//services
import {
  getDocumentInfo as _getDocumentInfo,
  resendInvitationSigning as _resendInvitationSigning,
} from '@/services/uspqrp/signatures-contractor.api';
import ParticipantSignatureStatus, {
  ParticipantSignatureStatusColor,
} from '@/utils/constants/ParticipantSignatureStatus.js';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';

//constants
import { contractDocumentTypes } from '@/utils/constants/contractDocumentTypes.js';
import { signatureTypeLabels } from '@/utils/constants/signatureTypes';
import { signatureStatus } from '@/utils/constants/signatureStatus';
import SignatureDocumentStatus from '@/utils/constants/signatureDocumentStatus.js';
import { getUserInformation as _getUserInformation } from '@/services/uspqrp/contract.api.js';
export default {
  name: 'SignatureDetail',
  mixins: [alertMixin],
  components: {
    CustomCallout,
    ActionButton,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
      required: false,
    },
    contractId: {
      type: Number,
      default: 0,
      required: false,
    },
  },
  isElectronicSignature: {
    type: Boolean,
    default: false,
  },
  data: () => ({
    signatures: [],
    documentData: [],
    signDate: null,
    contratoFirmado: contractDocumentTypes.contratoFirmado,
    signatureTypeLabels,
    signatureStatus,
    positions: ['PROVEEDOR', 'ESPECIALISTA'],
    lastEmittedDocumentStatusId: null,
  }),
  async mounted() {
    await this.getStatusParticipants();
  },
  methods: {
    statusColor(statusid) {
      const hashMap = {
        [ParticipantSignatureStatus.Signed]:
          ParticipantSignatureStatusColor[ParticipantSignatureStatus.Signed],

        [ParticipantSignatureStatus.PendingSignature]:
          ParticipantSignatureStatusColor[
            ParticipantSignatureStatus.PendingSignature
          ],
      };
      return hashMap[statusid ?? ParticipantSignatureStatus.Unset];
    },
    async getSignatures(dataStatus) {
      this.signatures = dataStatus.statusInformation.participants;
      const signaturesWithUserNames = await Promise.all(
        this.signatures.map(async (item) => {
          const rs = await _getUserInformation(item.userId);
          return {
            ...item,
            userName: rs.data.userName,
          };
        })
      );
      this.signatures = signaturesWithUserNames;
    },
    async getStatusParticipants() {
      if (this.data.digitalSignatureDocumentId) {
        const { data: docInfo } = await _getDocumentInfo(
          this.data.digitalSignatureDocumentId
        );
        this.documentData = [docInfo];
        const currentStatusId = docInfo?.statusInformation?.documentStatusId;
        if (
          currentStatusId === SignatureDocumentStatus.Signed &&
          this.lastEmittedDocumentStatusId !== currentStatusId
        ) {
          this.lastEmittedDocumentStatusId = currentStatusId;
          this.$emit('document-signed');
        }
        await this.getSignatures(docInfo);
      }
    },
    async onResendHandler(email, userId) {
      const { data } = await _resendInvitationSigning({
        email,
        documentId: this.data.digitalSignatureDocumentId,
        userId,
      });

      if (data) {
        this.ShowToast(
          'Alerta',
          'Se ha reenviado el mensaje satisfactoriamente.',
          'success'
        );
      } else {
        this.ShowToast(
          'Alerta',
          'Ocurrió un error, intente nuevamente.',
          'error'
        );
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
::v-deep .file-input-container {
  em {
    padding-right: 5px !important;
  }
}
.btn-action-size {
  width: 35px;
  height: 35px;
}
.border-top {
  border: 1px, 0px, 0px, 0px;
  border-color: #c3c3c3;
}
.file-replacement-input__extended ::v-deep {
  .file-input-container {
    width: 35px;
    height: 35px !important;
    border-color: map-get($colors, 'green');
    em {
      font-size: 18px;
      margin-left: -2px;
    }
    em.fas.fa-file-plus.pr-4.text-green:before {
      content: '\f0e2';
    }
    .file-select {
      span {
        display: none;
      }
    }
  }
}
</style>
